// extracted by mini-css-extract-plugin
module.exports = {"column":"OneColumn_column__1HQEv","gray":"OneColumn_gray__2l1Lq"};